export default __webpack_public_path__ + "static/media/MochaMattari.a95ff091.woff";